export default {
  feedback: {
    usage_threshold: 'Tämän kampanjan vähimmäisostoskorin summa on (ei sisällä toimituskuluja)',
    promo_code_added: 'Kampanjakoodi käytetty',
    promo_code_removed: 'Kampanjakoodi {{code}} poistettu',
  },
};
